import { render, staticRenderFns } from "./KanbanModal.vue?vue&type=template&id=9641007a"
import script from "./KanbanModal.vue?vue&type=script&lang=js"
export * from "./KanbanModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports